export function getFileName(file) {
    if ('name' in file) {
        return file.name;
    }
    if ('fileName' in file) {
        return file.fileName;
    }
    return '';
}
export function getFileType(file) {
    if ('type' in file) {
        return file.type;
    }
    if ('contentType' in file) {
        return file.contentType;
    }
    return '';
}
export function getFileExtension(file) {
    const name = getFileName(file);
    return name?.split('.').pop()?.toLowerCase() ?? '';
}
